// angular
import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../../app.service';
import { MeDashboardService } from '../../me-dashboard.service';
import { MeDiagnosisPredictionService } from './diagnosis-prediction.service';

@Component({
    selector: 'me-diagnosis-prediction-card',
    templateUrl: './diagnosis-prediction.component.html',
    styleUrls: ['./diagnosis-prediction.component.scss'],
    providers: [MeDiagnosisPredictionService]
})

export class MeDiagnosisPredictionCardComponent implements OnInit {
    data: any;
    url = 'dashboard/cards/diagnosis-prediction-card';
    predictionData;

    constructor(
        public appService: AppService,
        public translate: TranslateService,
        public route: ActivatedRoute,
        public router: Router,
        public meDiagnosisPredictionService: MeDiagnosisPredictionService,
        public meDashboardService: MeDashboardService
    ) {
       
    }

    ngOnInit() {
        this.getContent();
        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            this.getDiagnosisPrediction();
        }, error => {
            window.alert('Content not found');
            this.appService.isLoading = false;
            this.router.navigate(['me']);
        });
    }

    getDiagnosisPrediction() {
        this.meDiagnosisPredictionService.getDiagnosisPrediction().subscribe(res => {
            this.predictionData = res['data'];

            if (!this.predictionData) {
                this.meDashboardService.showPredictionCard = false;
            }
        });
    }
}
